export const en = {
    'no-rights': 'Not enough rights to apply the recommendations',
    'platform-accept-button': 'Allow',
    'platform-accept-progress-button': 'Allowing',
    'switch-on-autotargeting-button': 'Enable',
    'switch-on-autotargeting-progress-button': 'Enabling'
};
